module.exports = __webpack_public_path__ + "img/shipo-icon-calendar-time.8b90a139.svg";